import React, { useEffect } from 'react';
import Lights from './Lights.jsx';
import { Physics } from '@react-three/rapier';
import LandModel from './LandModel.jsx';
import Book from './Book.jsx';
import CharacterController from './CharacterController.jsx';
import useGame from './stores/useGame.js';
import Ground from './Ground.jsx';

export default function Experience({ setBooksCollected }) {
  const bookVisible = useGame((state) => state.bookVisible);
  const collectBook = useGame((state) => state.collectBook);

  const handleBookCollision = (index) => {
    collectBook(index); // Usamos la acción de Zustand
  };

  return (
    <>
      <Lights />
      <Physics>
        <group>
          <LandModel />
          <CharacterController onBookCollision={handleBookCollision} />
          <Book visible={bookVisible} />
          <Ground />
        </group>
      </Physics>
    </>
  );
}
